/**
 * @generated SignedSource<<e8333e6c1a840fa92d1ab1b47931235b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "FondySignResponse",
    "kind": "LinkedField",
    "name": "fondySign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reservationData",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkoutMasterWashPagesFondySignMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkoutMasterWashPagesFondySignMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f11e1f3bd9571165bca7c005ab8ca42",
    "id": null,
    "metadata": {},
    "name": "checkoutMasterWashPagesFondySignMutation",
    "operationKind": "mutation",
    "text": "mutation checkoutMasterWashPagesFondySignMutation(\n  $request: FondySignRequestInput\n) {\n  fondySign(request: $request) {\n    signature\n    orderId\n    reservationData\n  }\n}\n"
  }
};
})();

node.hash = "30ad22c40bb778ad2e6ba8296267f1b4";

module.exports = node;
